<page-heading
  [title]="t('contact.customerPortfolio.pageTitle', { suffix: user?.name ? '- ' + $safeNavigationMigration(user?.name) : '' })"
  [description]="'contact.customerPortfolio.pageDescription' | translate"
/>

<div class="card">
  <contact-list-component
    [toggleTableCard]="toggleTableCard"
    [showAddContactButton]="false"
    [showImportContactButton]="false"
    [showCards]="false"
    [idUserCustomerPortfolio]="idUser"
    [showActionCustomerPortfolioButtons]="true"
    [useSavedView]="false"
  ></contact-list-component>
</div>

<div>
  <button class="btn btn-outline-secondary" (click)="back()">{{ 'contact.customerPortfolio.back' | translate }}</button>
</div>
